import { withIdempotencyKey } from '@moneytome/shared';
import { api } from '../../api/client';
import type { MerchantApplicationRequest } from './payload';

/**
 * Submit the business application. The idempotency key is supplied by the
 * caller and stays stable across retries of one logical submission so a network
 * retry never creates a duplicate application.
 *
 * The path resolves to `POST /api/public/merchant-applications` (basePath lives
 * in ../../api/client).
 *
 * NOTE (residual, PLI-72): this is the backend's interim anonymous route. Once
 * the verified lead session lands, the application moves behind an authenticated
 * surface (`/lead/v1/merchant-applications`) and this path changes with it.
 */
export function submitApplication(payload: MerchantApplicationRequest, idempotencyKey: string) {
  return api('/merchant-applications', {
    method: 'POST',
    body: payload,
    ...withIdempotencyKey(idempotencyKey),
  });
}
